import { SonarTag } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type SonarTagsIdMapState = SyncState<Record<number, SonarTag>>;

export const defaultTagsIdMapState: SonarTagsIdMapState = { data: {} };
